const AdminProjectPhases = {
    Preparation: 1,
    Execution: 2,
    Evaluation: 3,
} as const;

export default AdminProjectPhases;
